import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import "core-js/modules/es6.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.promise.finally";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { eventDispatcher, SacAction, TOPICS } from '@origin-digital/event-dispatcher';
import { configSumoMeta, logger } from '@origin-digital/reporting-client';
import { isNative as isNativeFn, normalizeAllowedQueryNumbers, parseQuery, windowExists } from './helpers';
import { AemContextHub } from './aemContextHub';
import { addStorageUpdatedListener, fireSacUpdateEvent, readStorage, removeStorageUpdatedListener, srcUniqueId, writeStorage } from './sacStorage';
import { derivedContractAccounts } from './derivedContractAccounts';
import { fetchAppContext } from './api/sacDapi';
import { XHR_LOAD_ERROR } from './constants'; // tslint:disable-next-line:max-line-length
// https://stackoverflow.com/questions/53154564/how-to-get-all-possible-values-of-a-union-type-to-an-array-or-the-other-way-aro

function stringTuple() {
  for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
    data[_key] = arguments[_key];
  }

  return data;
}

var storageKeys = stringTuple('businessPartnerId', 'customerCode', 'premiseId', 'contractAccountId', 'properties');
var queryKeys = stringTuple('caid', 'premiseId');
var derivedQueryKeys = stringTuple('contractAccountId', 'premiseId');

var notInitialisedFn = function notInitialisedFn() {
  throw new Error('SharedAppProvider not initialised');
};

export var SharedAppContext = React.createContext({
  actions: {
    fetchXhrAppContext: notInitialisedFn,
    setContractAccountId: notInitialisedFn,
    setPremiseId: notInitialisedFn
  },
  isNative: false
});
var SAC_XHR_LOAD_ERROR = 'SAC_XHR_LOAD_ERROR';
var SharedAppConsumer = SharedAppContext.Consumer;
export { SharedAppConsumer };
export var SharedAppProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(SharedAppProvider, _React$Component);

  var _super = _createSuper(SharedAppProvider);

  // used to remember if we should an error banner to users
  function SharedAppProvider(props, _state) {
    var _this;

    _classCallCheck(this, SharedAppProvider);

    _this = _super.call(this, props, _state);

    _defineProperty(_assertThisInitialized(_this), "sacListenerUnSub", void 0);

    _defineProperty(_assertThisInitialized(_this), "storageListenerUnSub", void 0);

    _defineProperty(_assertThisInitialized(_this), "xhrErrorBanner", false);

    _defineProperty(_assertThisInitialized(_this), "queryParams", void 0);

    _defineProperty(_assertThisInitialized(_this), "actions", {
      fetchXhrAppContext: function fetchXhrAppContext() {
        var isError = false;
        fetchAppContext(_this.props.xhrHost).then(function (appContext) {
          if (appContext) {
            _this.updateState(appContext);

            if (configSumoMeta) {
              configSumoMeta({
                bpid: appContext.businessPartnerId,
                customerCode: appContext.customerCode
              });
            }
          } else {
            isError = true;
            logger.error('@od/sac: null appContext while fetching appContext');
          }
        }).catch(function (err) {
          isError = true;
          logger.error('@od/sac: error while fetching appContext', err);
        }).finally(function () {
          if (!_this.state.properties && isError) {
            _this.xhrErrorBanner = true;
            eventDispatcher.dispatch({
              payload: {
                message: XHR_LOAD_ERROR,
                type: 'error',
                uniqueId: SAC_XHR_LOAD_ERROR
              },
              topic: TOPICS.ALERT_BANNER_OPEN
            });
          }
        });
      },
      setContractAccountId: function setContractAccountId(contractAccountId) {
        _this.updateState({
          contractAccountId: contractAccountId
        });
      },
      setPremiseId: function setPremiseId(premiseId) {
        AemContextHub.setPremiseId(premiseId);

        _this.updateState({
          premiseId: premiseId
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "queryState", function () {
      var queryString = windowExists ? window.location.search : undefined;

      if (queryString) {
        var query = parseQuery(queryString);
        return normalizeAllowedQueryNumbers(query, queryKeys);
      } else {
        return {};
      }
    });

    _defineProperty(_assertThisInitialized(_this), "initState", function (storage, query) {
      var premiseId = _this.initPremiseId(query.premiseId, storage.premiseId);

      var contractAccountId = _this.initContractAccountId(storage, premiseId, query.contractAccountId);

      var newState = _objectSpread({}, storage, {
        contractAccountId: contractAccountId,
        premiseId: premiseId
      });

      var updateStorage = false;

      if (storage.properties) {
        var derivedContracts = derivedContractAccounts(storage.properties, query, premiseId, contractAccountId);

        if (derivedContracts) {
          newState = _objectSpread({}, newState, {}, derivedContracts);
        }
      } else {
        // save these to be used once we have properties
        _this.queryParams = query;
      }

      if (storage.premiseId !== newState.premiseId) {
        updateStorage = true;
      }

      if (storage.contractAccountId !== newState.contractAccountId) {
        updateStorage = true;
      }

      if (updateStorage) {
        _this.updateStorage(newState);
      }

      return newState;
    });

    _defineProperty(_assertThisInitialized(_this), "addSacUpdateListener", function () {
      // this is used to sync when there are two SACs on one page
      _this.sacListenerUnSub = eventDispatcher.addListener(TOPICS.SAC_UPDATE, function (topic) {
        if (topic.topic === TOPICS.SAC_UPDATE) {
          var action = topic.payload.action;
          var _this$actions = _this.actions,
              setPremiseId = _this$actions.setPremiseId,
              setContractAccountId = _this$actions.setContractAccountId,
              fetchXhrAppContext = _this$actions.fetchXhrAppContext;

          if (action) {
            switch (action.action) {
              case SacAction.setPremiseId:
                setPremiseId(action.parameters.premiseId);
                break;

              case SacAction.setContractAccountId:
                setContractAccountId(action.parameters.contractAccountId);
                break;

              case SacAction.fetchXhrAppContext:
                fetchXhrAppContext();
                break;

              default:
                throw new Error('SAC action provided does not exist: ' + action);
            }
          } else if (topic.payload.srcUniqueId !== srcUniqueId) {
            // ensures that we don't listen for our own event
            _this.updateState(readStorage(), true);
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (newState, dontFireEvent) {
      // ensures that state has changed
      var updatedState = _Object$keys(newState).filter(function (key) {
        return _this.state[key] !== newState[key];
      }).reduce(function (state, key) {
        state[key] = newState[key];
        return state;
      }, {});

      if (_Object$keys(updatedState).length > 0) {
        _this.setState(function (prevState) {
          var state = _objectSpread({}, prevState, {}, updatedState);

          if (newState.properties || newState.premiseId) {
            var derivedState = derivedContractAccounts(state.properties, !dontFireEvent ? _this.queryParams : undefined, state.premiseId, state.contractAccountId //
            );

            if (derivedState) {
              state = _objectSpread({}, state, {}, derivedState); // only allow query params change state once

              _this.queryParams = undefined;
            }
          } // hides the error banner if previously shown


          if (state.properties && _this.xhrErrorBanner) {
            _this.xhrErrorBanner = false;
            eventDispatcher.dispatch({
              payload: {
                uniqueId: SAC_XHR_LOAD_ERROR
              },
              topic: TOPICS.ALERT_BANNER_CLOSE
            });
          } // TODO fire in new thread?


          _this.updateStorage(state, dontFireEvent);

          return state;
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateStorage", function (state, dontFireEvent) {
      var storageObj = _Object$keys(state).filter(function (key) {
        return storageKeys.includes(key);
      }).reduce(function (storage, key) {
        storage[key] = state[key];
        return storage;
      }, {});

      writeStorage(storageObj);

      if (!dontFireEvent) {
        fireSacUpdateEvent();
      }
    });

    _this.init();

    return _this;
  }

  _createClass(SharedAppProvider, [{
    key: "init",
    value: function init() {
      var queryParams = this.queryState();
      var isNative = isNativeFn();
      var stateFromConfig = this.props.stateFromConfig;

      if (stateFromConfig) {
        if (process.env.NODE_ENV !== "production") {
          this.state = _objectSpread({}, stateFromConfig, {}, queryParams, {
            isNative: isNative
          });
          return;
        } else {
          logger.error('@od/sac should not be initialized via props outside of DEV');
        }
      }

      var storage = readStorage();
      var derivedStorage = this.initState(storage, queryParams);
      this.state = _objectSpread({}, derivedStorage, {
        isNative: isNative
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // this is used to sync SACs across multiple webviews
      this.storageListenerUnSub = addStorageUpdatedListener(function () {
        return _this2.updateState(readStorage(), true);
      });
      this.addSacUpdateListener();

      if (this.props.xhrInitialize) {
        this.actions.fetchXhrAppContext();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.storageListenerUnSub) {
        removeStorageUpdatedListener(this.storageListenerUnSub);
        this.storageListenerUnSub = undefined;
      }

      if (this.sacListenerUnSub) {
        this.sacListenerUnSub();
        this.sacListenerUnSub = undefined;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var value = _objectSpread({}, this.state, {
        actions: this.actions
      });

      return /*#__PURE__*/React.createElement(SharedAppContext.Provider, {
        value: value
      }, this.props.children);
    }
  }, {
    key: "initPremiseId",
    value: function initPremiseId(fromQuery, fromStorage) {
      if (fromQuery) {
        return fromQuery;
      }

      var fromCookie = AemContextHub.getPremiseIdFromCookie();

      if (fromCookie) {
        return fromCookie;
      }

      if (fromStorage) {
        return fromStorage;
      }

      var fromHub = AemContextHub.getPremiseIdFromContextHub();

      if (fromHub) {
        return fromHub;
      }

      return;
    }
  }, {
    key: "initContractAccountId",
    value: function initContractAccountId(storage, premiseId, fromQuery) {
      if (fromQuery) {
        return fromQuery;
      }

      if (storage.premiseId === premiseId && storage.contractAccountId) {
        return storage.contractAccountId;
      }

      if (premiseId) {
        var fromContextHub = AemContextHub.deriveContractAccountId(premiseId);

        if (fromContextHub) {
          return fromContextHub;
        }
      }

      return;
    }
  }]);

  return SharedAppProvider;
}(React.Component);